import { render } from "./HomeSlider.vue?vue&type=template&id=3de4d362"
import script from "./HomeSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlider.vue?vue&type=script&lang=js"

import "./HomeSlider.vue?vue&type=style&index=0&id=3de4d362&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__